import React from 'react';
import {
  CheckCircle2,
  Clock,
  XCircle,
  BookOpen,
  Archive
} from 'lucide-react';
import type { BookStatus } from '../../../../shared/types/index.js';

interface BookStatusBadgeProps {
  status: BookStatus;
  className?: string;
}

export const BookStatusBadge: React.FC<BookStatusBadgeProps> = ({ status, className = '' }) => {
  switch (status) {
    case 'disetujui':
      return (
        <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200 ${className}`}>
          <CheckCircle2 className="w-3 h-3 shrink-0" />
          <span>Disetujui</span>
        </span>
      );
    case 'diajukan':
      return (
        <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-amber-50 text-amber-700 border border-amber-200 ${className}`}>
          <Clock className="w-3 h-3 shrink-0" />
          <span>Diajukan</span>
        </span>
      );
    case 'menunggu_penerbit':
      return (
        <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-indigo-50 text-indigo-700 border border-indigo-200 ${className}`}>
          <Clock className="w-3 h-3 shrink-0" />
          <span>Menunggu Penerbit</span>
        </span>
      );
    case 'ditolak':
      return (
        <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-rose-50 text-rose-700 border border-rose-200 ${className}`}>
          <XCircle className="w-3 h-3 shrink-0" />
          <span>Ditolak</span>
        </span>
      );
    case 'draft':
      return (
        <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-slate-100 text-slate-700 border border-slate-200 ${className}`}>
          <BookOpen className="w-3 h-3 shrink-0" />
          <span>Draft</span>
        </span>
      );
    case 'diarsipkan':
      return (
        <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-stone-100 text-stone-600 border border-stone-200 ${className}`}>
          <Archive className="w-3 h-3 shrink-0" />
          <span>Diarsipkan</span>
        </span>
      );
    default:
      return null;
  }
};
